<app-dataspace-report-workspace-layout
  [title]="'Connector'"
  [subtitle]="'Verwaltung von Data Offers und Policies'"
  [stats]="stats">

  <div workspace-sidebar class="dataspace-pane connector-pane">
    <div class="connector-pane__toolbar">
      <button mat-raised-button color="primary" class="connector-pane__create" (click)="createNewOffer()">
        <mat-icon>add</mat-icon>
        Neues Data Offer
      </button>
      <p>Der Connector verwaltet persistierte Data Offers mit Filtern, Abschnittsauswahl und Policy-Regeln als backendseitige Angebotsdefinition.</p>
    </div>

    <div class="connector-offer-list" *ngIf="offers.length">
      <button
        type="button"
        class="connector-offer-card"
        *ngFor="let offer of offers"
        [class.is-selected]="selectedOfferId === offer.id"
        (click)="selectOffer(offer)">
        <div class="connector-offer-card__topline">
          <span class="connector-offer-card__status" [class.is-published]="offer.status === 'PUBLISHED'">
            {{ getStatusLabel(offer.status) }}
          </span>
          <div class="connector-offer-card__actions">
            <span class="connector-offer-card__date">{{ offer.lastUpdated | date:'dd.MM.yyyy' }}</span>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Entwurf löschen"
              *ngIf="offer.status === 'DRAFT'"
              (click)="deleteOffer(offer, $event)">
              <mat-icon>delete</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Data Offer widerrufen"
              *ngIf="offer.status === 'PUBLISHED'"
              (click)="revokeOffer(offer, $event)">
              <mat-icon>block</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Als ungültig markieren"
              *ngIf="offer.status === 'PUBLISHED' || offer.status === 'REVOKED' || offer.status === 'DRAFT'"
              (click)="invalidateOffer(offer, $event)">
              <mat-icon>gpp_bad</mat-icon>
            </button>
          </div>
        </div>
        <strong>{{ offer.title }}</strong>
        <p>{{ offer.description }}</p>
        <div class="connector-offer-card__meta">
          <span>{{ getOfferSubtitle(offer) }}</span>
        </div>
      </button>
    </div>

    <mat-card class="dataspace-empty-state" *ngIf="!offers.length">
      <mat-icon>hub</mat-icon>
      <strong>Keine Data Offers</strong>
      <span>Erstellen Sie Ihr erstes Datenangebot für den Dataspace.</span>
    </mat-card>
  </div>

  <div workspace-detail class="dataspace-detail connector-detail" *ngIf="editingOffer; else emptyState">
    <mat-card class="connector-hero">
      <div class="connector-hero__content">
        <div class="dataspace-detail__eyebrow">Data Offer</div>
        <input
          class="connector-hero__name-input"
          type="text"
          [ngModel]="editingOffer.title"
          (ngModelChange)="onTitleInput($event)"
          placeholder="Name des Data Offers">
        <textarea
          class="connector-hero__desc-input"
          [(ngModel)]="editingOffer.description"
          placeholder="Beschreibung"
          rows="2"></textarea>
      </div>
      <div class="connector-hero__chips">
        <span class="connector-chip connector-chip--status" [class.is-published]="editingOffer.status === 'PUBLISHED'">
          {{ getStatusLabel(editingOffer.status) }}
        </span>
        <span class="connector-chip">{{ contractModeLabel }}</span>
        <span class="connector-chip">{{ accessVisibilityLabel }}</span>
      </div>
    </mat-card>

    <div class="connector-summary-grid">
      <mat-card class="connector-summary-card">
        <span class="connector-summary-card__label">Angebotene Daten</span>
        <strong>{{ dataSelectionLabel }}</strong>
        <p>{{ sectionSelection.length }} Abschnitte im Offer enthalten</p>
      </mat-card>

      <mat-card class="connector-summary-card">
        <span class="connector-summary-card__label">Contract Policy</span>
        <strong>{{ contractModeLabel }}</strong>
        <p>{{ editingOffer.pricing.type === 'PAID' ? 'Kostenpflichtig' : 'Kostenfrei' }}</p>
      </mat-card>

      <mat-card class="connector-summary-card">
        <span class="connector-summary-card__label">Export</span>
        <strong>{{ exportFormatLabel }}</strong>
      </mat-card>
    </div>

    <div class="dataspace-detail__grid connector-detail__grid">
      <mat-card class="dataspace-detail__card connector-card connector-card--builder">
        <div class="dataspace-card__header connector-card__header">
          <div>
            <h4>Asset Definition</h4>
            <p>Definieren Sie präzise, welche NU-Berichte per Status- und Datumsfilter sowie welche Abschnitte in dieses Data Offer einfließen.</p>
          </div>
        </div>
        <app-asset-rule-builder
          [assetRules]="editingOffer.assetRules"
          [sectionOptions]="sectionOptions"
          (assetRulesChange)="updateAssetRules($event)">
        </app-asset-rule-builder>
      </mat-card>

      <mat-card class="dataspace-detail__card connector-card connector-card--policy">
        <div class="dataspace-card__header connector-card__header">
          <div>
            <h4>Policies</h4>
            <p>Legen Sie fest, wer das Angebot im Catalog sehen kann und welche Nutzung nach Vertragsabschluss erlaubt ist.</p>
          </div>
        </div>
        <app-policy-editor
          [accessPolicy]="editingOffer.accessPolicy"
          [contractPolicy]="editingOffer.contractPolicy"
          [pricing]="editingOffer.pricing"
          [availableOrganisations]="availableOrganisations"
          (policiesChange)="updatePolicies($event)">
        </app-policy-editor>
      </mat-card>
    </div>

    <div class="connector-insight-grid">
      <mat-card class="connector-insight-card">
        <div class="connector-insight-card__title">Im Offer enthaltene Abschnitte</div>
        <div class="connector-section-groups" *ngIf="groupedSelectedSections.length; else noSections">
          <div class="connector-section-group" *ngFor="let group of groupedSelectedSections">
            <strong>{{ group.title }}</strong>
            <div class="connector-section-pills">
              <span class="connector-section-pill" *ngFor="let section of group.items">{{ section.label }}</span>
            </div>
          </div>
        </div>
        <ng-template #noSections>
          <p>Es sind noch keine Abschnitte ausgewählt.</p>
        </ng-template>
      </mat-card>

      <mat-card class="connector-insight-card">
        <div class="connector-insight-card__title">Policy Zusammenfassung</div>
        <dl class="connector-policy-summary">
          <div>
            <dt>Access Policy</dt>
            <dd>{{ editingOffer.accessPolicy.catalogAudienceLabel }}</dd>
          </div>
          <div>
            <dt>Contract Policy</dt>
            <dd>{{ contractModeLabel }}</dd>
          </div>
          <div>
            <dt>Erlaubte Formate</dt>
            <dd>{{ exportFormatLabel }}</dd>
          </div>
          <div>
            <dt>Pricing</dt>
            <dd>{{ editingOffer.pricing.type === 'PAID' ? (editingOffer.pricing.amount + ' ' + editingOffer.pricing.currency + ' / ' + editingOffer.pricing.billingBasis) : 'Kostenfrei' }}</dd>
          </div>
          <div>
            <dt>Suchfilter</dt>
            <dd>{{ editingOffer.assetRules.searchTerm || 'Keine zusätzliche Volltextsuche definiert' }}</dd>
          </div>
        </dl>
      </mat-card>
    </div>

    <div class="dataspace-action-row connector-action-row">
      <button mat-raised-button color="primary" (click)="saveOffer()">{{ primaryActionLabel }}</button>
      <button mat-button *ngIf="editingOffer.status !== 'PUBLISHED'" (click)="saveDraft()">Entwurf speichern</button>
      <button
        mat-stroked-button
        color="warn"
        *ngIf="editingOffer.status !== 'PUBLISHED'"
        (click)="deleteOffer(editingOffer)">
        Data Offer löschen
      </button>
      <button
        mat-stroked-button
        color="warn"
        *ngIf="editingOffer.status === 'PUBLISHED'"
        (click)="revokeOffer(editingOffer)">
        Data Offer widerrufen
      </button>
      <button
        mat-stroked-button
        color="warn"
        *ngIf="editingOffer.status !== 'ARCHIVED' && editingOffer.status !== 'INVALID'"
        (click)="invalidateOffer(editingOffer)">
        Als ungueltig markieren
      </button>
    </div>
  </div>

  <ng-template #emptyState>
    <mat-card class="dataspace-empty-state">
      <mat-icon>settings_input_component</mat-icon>
      <strong>Wählen Sie ein Angebot aus</strong>
      <span>Öffnen Sie ein vorhandenes Data Offer oder erstellen Sie ein neues, um Regeln und Policies zu definieren.</span>
    </mat-card>
  </ng-template>
</app-dataspace-report-workspace-layout>
